import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ComboBox from '../../../../../components/ComboBox';
import CollectionDataSource from '../../../../../dao/DataSource/CollectionDataSource';
import BaseComponent from '../../../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure

import './DirectoryFilter.scss';
class DirectoryFilter extends BaseComponent {
  constructor(props) {

    super(props);
    this.state = {
      selectedMarket:
        props.selectedFilters && props.selectedFilters.market
          ? props.selectedFilters.market
          : null,
      selectedMarketItems: props.selectedFilters && props.selectedFilters.market
        ? props.selectedFilters.market
        : null,
      selectedCompanyItems: props.selectedFilters && props.selectedFilters.company
        ? props.selectedFilters.company
        : null,
      selectedPermissionItems: props.selectedFilters && props.selectedFilters.permission
        ? props.selectedFilters.permission
        : null,
      selectedCompany:
        props.selectedFilters && props.selectedFilters.company
          ? props.selectedFilters.company
          : null,
      selectedPermission:
        props.selectedFilters && props.selectedFilters.permission
          ? props.selectedFilters.permission
          : null,
      selectedDocumentType:
        props.selectedFilters && props.selectedFilters.documentType
          ? props.selectedFilters.documentType
          : null,
      startDate:
        props.selectedFilters && props.selectedFilters.startDate
          ? props.selectedFilters.startDate
          : null,
      endDate:
        props.selectedFilters && props.selectedFilters.endDate
          ? props.selectedFilters.endDate
          : null,
    };

  }

  componentDidUpdate(prevProps) {
    const nextProps = this.props;

    if (
      nextProps.selectedFilters != prevProps.selectedFilters &&
      nextProps.selectedFilters
    ) {
      this.setState({
        selectedMarket:
          nextProps.selectedFilters && nextProps.selectedFilters.market
            ? nextProps.selectedFilters.market
            : null,

        selectedCompany:
          nextProps.selectedFilters && nextProps.selectedFilters.company
            ? nextProps.selectedFilters.company
            : null,
        selectedPermission:
          nextProps.selectedFilters && nextProps.selectedFilters.permission
            ? nextProps.selectedFilters.permission
            : null,
        selectedDocumentType:
          nextProps.selectedFilters && nextProps.selectedFilters.documentType
            ? nextProps.selectedFilters.documentType
            : null,
        startDate:
          nextProps.selectedFilters && nextProps.selectedFilters.startDate
            ? nextProps.selectedFilters.startDate
            : null,
        endDate:
          nextProps.selectedFilters && nextProps.selectedFilters.endDate
            ? nextProps.selectedFilters.endDate
            : null,
      });
    }
  }

  handleUpdateMarkets(markets) {
    this.setState({ markets: markets });
  }
  componentDidMount() {
    this.marketsDataSource = new CollectionDataSource('MarketsCollection', 'Market', { markets: {} }, this.handleUpdateMarkets);
    this.marketsDataSource.current();
    // console.log(this.props.selectedFilters)
  }

  handleCloseMenu() {
    if (this.state.menu) {
      this.setState({ menu: null, displayMenu: '' });
    }
  }

  // handleMarketChange(type, option) {
  //   const { handleMarketSelection } = this.props
  //   if (handleMarketSelection) {
  //     this.setState({
  //       selectedMarket: type
  //     })
  //     handleMarketSelection(type == 'allMarkets' ? null : type)
  //   }
  // }

  handleMarketChange(type, option){

    const { handleMarketSelection } = this.props;
    if (handleMarketSelection) {
      this.setState({
        selectedMarket: type,
        selectedMarketItems: type,
      });
      handleMarketSelection(type);
    }

  }

  handleCompanyChange(type, option) {

    const { handleCompanySelection } = this.props;
    if (handleCompanySelection) {
      this.setState({
        selectedCompany: type,
        selectedCompanyItems: type,
      });
      handleCompanySelection(type);
    }
  }

  handlePermissionChange(type, option) {

    const { handlePermissionSelection } = this.props;
    if (handlePermissionSelection) {
      this.setState({
        selectedPermission: type,
        selectedPermissionItems: type,
      });
      handlePermissionSelection(type);
    }
  }

  handleDocumentTypeChange(type, option) {
    const { handleDocumentTypeSelection } = this.props;
    if (handleDocumentTypeSelection) {
      this.setState({
        selectedDocumentType: type,
      });
      handleDocumentTypeSelection(type == 'allDocumentTypes' ? null : type);
    }
  }

  handleStartDateSelection(date) {
    const { handleStartDateSelection } = this.props;
    if (handleStartDateSelection) {
      handleStartDateSelection(date);
      this.setState({
        startDate: date,
      });
    }
  }

  handleEndDateSelection(date) {
    const { handleEndDateSelection } = this.props;
    if (handleEndDateSelection) {
      handleEndDateSelection(date);
      this.setState({
        endDate: date,
      });
    }
  }

  render() {
    let {  selectedMarketItems, selectedCompanyItems,
      selectedPermissionItems } = this.state;

    let marketsList = [];

    if (this.state.markets) {
      this.state.markets.forEach(market => {
        let marketOption = {
          type: market.id,
          id: market.id,
          name: market.name,
          selected: false,
          market: market,
        };
        marketsList.push(marketOption);
      });
    }

    if(selectedMarketItems){

      marketsList.forEach(m => {
        if(selectedMarketItems.some(s => m.id == s.id)) {
          m.selected = true;
        }

      });
    }

    let marketSelector = (
      <ComboBox
        key={'marketPicker'}
        id={'marketPicker'}
        options={marketsList }
        currentOption={selectedMarketItems}
        hasBorder={false}
        underlined={false}
        height={31}
        multiSelect={true}
        width={238}
        menuHeight={120}
        displayFontStyle={{ fontSize: '14px' }}
        handleMultiMenuSelection={this.handleMarketChange}
      />
    // <div className='market field'>
    //   <MarketComboBox
    //   handleSelectMarket={this.handleMarketChange}
    //   markets={this.props.markets}
    //   height={32}
    //   width={219}
    //   hasBorder={false}
    //   multiSelect={true}
    //   defaultText={'Markets'}
    //   displayFontStyle={{ fontSize: "12px", fontFamily: "Open Sans", color: "#000000", textIndent: "10px", marginTop: "11px" }}

    // />
    // </div>
    );

    let companyList = [];
    if (_.isArray(this.props.companies)) {
      this.props.companies.forEach(company => {
        let companyOption = {
          type: company.id,
          id: company.id,
          name: company.name,
          selected: false,
          company: company,
        };
        companyList.push(companyOption);
      });
    }

    if(selectedCompanyItems){
      companyList.forEach(m => {
        if(selectedCompanyItems.some(s => m.id == s.id)) {
          m.selected = true;
        }
      });
    }

    // companyList.sort((c1, c2) => {
    //   if (c1.name < c2.name) {
    //     return -1
    //   } else if (c1.name > c2.name) {
    //     return 1
    //   } else {
    //     return 0
    //   }
    // })
    let companySelector = (
      <ComboBox
        key={'companyPicker'}
        id={'companyPicker'}
        options={companyList}
        currentOption={selectedCompanyItems}
        hasBorder={false}
        underlined={false}
        height={31}
        multiSelect={true}
        width={238}
        menuHeight={120}
        displayFontStyle={{ fontSize: '14px' }}
        handleMultiMenuSelection={this.handleCompanyChange}

      />
    );

    let RolesList = [];

    if (this.props.userRoles) {
      this.props.userRoles.forEach(permission => {
        let permissionOption = {
          type: permission.id,
          selected: false,
          id: permission.id,
          name: permission.description,
        };
        RolesList.push(permissionOption);
      });
    }

    if(selectedPermissionItems){

      RolesList.forEach(m => {
        if(selectedPermissionItems.some(s => m.id == s.id)) {
          m.selected = true;
        }

      });
    }

    // RolesList.sort((c1, c2) => {
    //   if (c1.name < c2.name) {
    //     return -1
    //   } else if (c1.name > c2.name) {
    //     return 1
    //   } else {
    //     return 0
    //   }
    // })
    let permissionSelector = (
      <ComboBox
        key={'permissionPicker'}
        id={'permissionPicker'}
        options={RolesList}
        multiSelect={true}
        currentOption={selectedPermissionItems}
        hasBorder={false}
        underlined={false}
        height={31}
        width={238}
        menuHeight={120}
        displayFontStyle={{ fontSize: '14px' }}
        handleMultiMenuSelection={this.handlePermissionChange}
      />
    );

    return (

      <div className="directory-users-filters">
      <div className='directory-users-markets-container'>
        <div className="directory-users-filter-selector-label">{this.textMap.market.toUpperCase()}</div>
        <div className="directory-users-filter-selector-container">{marketSelector}</div>
      </div>
      <div className='directory-users-markets-container'>
        <div className="directory-users-filter-selector-label">{this.textMap.company.toUpperCase()}</div>
        <div className="directory-users-filter-selector-container">{companySelector}</div>
      </div>

      <div className='directory-users-markets-container'>
        <div className="directory-users-filter-selector-label">{this.textMap.permission.toUpperCase()}</div>
        <div className="directory-users-filter-selector-container">{permissionSelector}</div>
      </div>

      {/* <div className='directory-users-date-selector-container'>
        {startDate}
        {endDate}
      </div> */}
    </div>

    );
  }
}

const mapStateToProps = (state, ownProps) => {

  return {
    permissions: state.new_users.permissions,
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
    activitiesList: state.activityLogs.activitiesList,
    userRoles: state.new_users.userRoles,
  };
};

export default connect(mapStateToProps)(DirectoryFilter);



// WEBPACK FOOTER //
// ./src/containers/Directory/DirectorySearchFilter/DirectoryFilterPopout/DirectoryFilter/index.js